import cookieHandler from '../utils/_cookieHandler';

const DEFAULT_COOKIE_EXPIRATION_DAYS = 7; // FE fallback

class mHeaderBanner extends HTMLDivElement {
    constructor() {
        super();
        this.closeBtn = this.querySelector('.close');
        this.swiper = this.querySelector('.swiper-wrapper');
        this.cookieDuration = !Number.isNaN(parseInt(this.dataset.cookieDuration, 10)) ? parseInt(this.dataset.cookieDuration, 10) : DEFAULT_COOKIE_EXPIRATION_DAYS;

        // bind this
        this.closeBanner = this.closeBanner.bind(this);
    }

    connectedCallback() {
        document.documentElement.style.setProperty('--header-banner-height', this.offsetHeight + 'px');
        if (this.closeBtn) this.closeBtn.addEventListener('click', this.closeBanner);
    }

    closeBanner() {
        cookieHandler.create('hasCloseBanner', true, this.cookieDuration);
        document.documentElement.style.setProperty('--header-banner-height', '0px');
        this.remove();
    }
}

customElements.define('m-header-banner', mHeaderBanner, {
    extends: 'div'
});
